import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { isEmpty } from 'b2b-apps/shop/common/utils/empty/empty';
import { createKey } from 'b2b-apps/shop/common/utils/key/key';
import { ProductGroupType } from 'b2b-apps/shop/content/common';
import { ProductBoxes } from './ProductBoxes';
import { ComponentType, Props } from './';
import './ProductBoxListV2.scss';

const ProductBoxListV2: ComponentType = ({
  componentData,
  className,
  isHomePage,
}: Props): ReactElement | null => {
  const {
    products: productGroups,
  } = componentData;

  if (isEmpty(componentData) || !Array.isArray(productGroups)) {
    return null;
  }

  const productListContainerClassName = classNames('cds-cms-ModuleContainer', {
    'ProductListModuleV2--HomePage': isHomePage,
  });

  return (
    <>
      {productGroups.map(
        (productGroup: ProductGroupType, index: number): ReactElement | null => (
          <div
            className={classNames('cds-cms-GridRow', className)}
            key={createKey('products-group', index)}
          >
            <div className={productListContainerClassName}>
              <ProductBoxes productGroup={productGroup} />
            </div>
          </div>
        ),
      )}
    </>
  );
};

export { ProductBoxListV2 };
